import styled from "styled-components";
import { Card, Form } from "antd";

export const AccountDetailsCard = styled(Card)`
    width: 100% !important;
    border-radius: 6px !important;
    margin-bottom: 4px !important;
    .ant-card-body {
        padding: 10px !important;
        transition: all 0.3s;
    }
    .label {
        display: block;
        cursor: pointer;
        font-weight: bold;
        margin: 2px;
    }
    .ant-form-item {
        margin: 0 !important;
    }
`;

export const SplitAccountsConfigForm = styled(Form)`
    position: relative !important;
    .footer {
        position: fixed;
        bottom: 0;
        background: #ffff;
        height: 60px;
        display: flex;
        align-items: center;
        justify-content: ${(props) => (props.splitType !== "percentage" ? `flex-end` : `space-between`)};
        z-index: 999;
        width: -webkit-fill-available;
        margin-left: -24px;

        .btn {
            margin: auto 10px auto 0;
        }
    }
`;
